<template src="./LoginPage.html" />
<script>
import { serverUrl } from '@/serverUrl';
import axios from 'axios';

export default {
    name: 'LoginPage',

    data() {
        return {
            username: '',
            password: ''
        };
    },

    methods: {
        async login(event) {
            event.preventDefault(); // Evita il comportamento predefinito del form

            try {
                console.log(serverUrl);
                console.log(this.username, this.password);

                const response = await axios.post(`${serverUrl}/auth/login`, {
                    username: this.username,
                    password: this.password
                });

                const token = response.data.token;
                localStorage.setItem('token', token);
                this.$router.push('/galleria-foto'); // Accedi a $router tramite this
            } catch (err) {
                alert('Credenziali Errate');
            }
        }
    }
};
</script>
<style scoped></style>